import { Feature } from '@bb/automaton';
import { featureEnabled } from 'utils';

export const adminsHomePage = '/listing/list/brokerage/0';
export const agentsHomePage = '/my_business';
export const answeringHomePage = '/answering/brokerages';
export const mlsStaffUsersPage = '/mls/users';
export const mlsStaffLockboxesPage = '/mls/lockboxes';
export const mlsStaffBrokeragesPage = '/mls/brokerages';
export const mlsStaffQuickAssignmentPage = '/mls/quick-assignment';
export const answeringSettingsPage = '/answering/settings';
export const viewContractsPage = '/mls/contracts';

export const mlsStaffFeaturePageMap: { [key in Feature]?: string } = {
  [Feature.MLS_STAFF_MANAGE_USERS]: mlsStaffUsersPage,
  [Feature.MLS_STAFF_MANAGE_LOCKBOXES]: mlsStaffLockboxesPage,
  [Feature.MLS_STAFF_MANAGE_BROKERAGES]: mlsStaffBrokeragesPage,
  [Feature.MLS_STAFF_QUICK_LOCKBOX_ASSIGNMENT]: mlsStaffQuickAssignmentPage,
  [Feature.ADMIN]: answeringSettingsPage,
  [Feature.MLS_STAFF_VIEW_CONTRACTS]: viewContractsPage,
};
